import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquareOff, TrendingUp, Zap } from 'lucide-react';
const features = [{
  icon: MessageSquareOff,
  title: 'Regla 100% Chat',
  description: 'Cero llamadas por Zoom. Todo se gestiona de forma asíncrona y rápida por chat para no perder tiempo.',
  color: 'text-[#00E5FF]',
  bg: 'bg-[#00E5FF]/10',
  border: 'border-[#00E5FF]/20'
}, {
  icon: TrendingUp,
  title: 'Enfoque en ROAS',
  description: 'No hacemos arte, hacemos anuncios de respuesta directa diseñados exclusivamente para convertir.',
  color: 'text-[#95BF47]',
  bg: 'bg-[#95BF47]/10',
  border: 'border-[#95BF47]/20'
}, {
  icon: Zap,
  title: 'Ejecución Rápida',
  description: 'Entregas veloces gracias a nuestra infraestructura impulsada por IA. Tu batch listo cuando lo necesitas.',
  color: 'text-[#FFD700]',
  bg: 'bg-[#FFD700]/10',
  border: 'border-[#FFD700]/20'
}];
export function Efficiency() {
  return <section className="pt-10 pb-24 px-4 sm:px-6 lg:px-8 bg-[#050505] relative z-20" data-id="element-11">
      <div className="max-w-7xl mx-auto" data-id="element-12">
        <div className="text-center mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-14">
            El Motor de Eficiencia
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-15">
            Cómo logramos resultados superiores en tiempo récord.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-16">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`p-8 rounded-2xl bg-[#111] border ${feature.border} hover:bg-[#151515] transition-colors`} data-id="element-17">
              <div className={`w-14 h-14 rounded-xl ${feature.bg} flex items-center justify-center mb-6`} data-id="element-18">
                <feature.icon className={`w-7 h-7 ${feature.color}`} data-id="element-19" />
              </div>
              <h3 className="text-2xl font-bold mb-3 text-white" data-id="element-20">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-21">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}